module.exports = __webpack_public_path__ + "img/cyberboard.951dfeed.gif";